import { render, staticRenderFns } from "./DealInfo.vue?vue&type=template&id=62be2eec"
import script from "./DealInfo.vue?vue&type=script&lang=js"
export * from "./DealInfo.vue?vue&type=script&lang=js"
import style0 from "./DealInfo.vue?vue&type=style&index=0&id=62be2eec&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports